import { FunnelMode, progressOf } from "./funnelProgress";
import { Bubble, OpenState } from "./funnelMembers";
import { DateParams } from "./funnelMetrics";

/*
 * THE FUNNEL IN PLAYBACK (2026-10-18). A replayed day has no "open visitors" list from a server: the visitors on the grid are the ones the playback has drawn so far, and playbackService knows
 * the pages each of them has been shown (playbackModeService.pathSoFar). So the spotlight is judged from that - the SAME rule as the numbers (funnelProgress.ts) - instead of being advanced
 * bubble by bubble: after a seek the grid is redrawn at each visitor's net state (their current page only), which would lose a visitor who is part-way through the funnel.
 */

/** The whole local day `date` ("YYYY-MM-DD", the playback's own calendar date) as the range the numbers are asked for. */
export const dayRange = (date: string): DateParams => {
  const [year, month, day] = date.split("-").map(Number);
  const start = new Date(year, month - 1, day, 0, 0, 0, 0).getTime();
  const next = new Date(year, month - 1, day + 1, 0, 0, 0, 0).getTime();

  return { startDate: new Date(start).toISOString(), endDate: new Date(next - 1).toISOString() };
};

/**
 * The funnel as the replay's clock has it: the day's range plus the instant reached, to the MINUTE (the readout shows minutes, and a number that moved every frame would only be a
 * stream of requests). No clock (nothing loaded) = the whole day.
 */
export const withClock = (range: DateParams, clockMs: number | null): DateParams =>
  clockMs === null || !Number.isFinite(clockMs) ? range : { ...range, asOf: Math.floor(clockMs / 60000) * 60000 };

/**
 * Where every visitor on the grid is in the funnel, given the pages each has been shown so far. A visitor playback cannot account for is judged by the one page the bubble is on - which is all
 * that is known about them - so a visitor seen mid-way is never lit by guesswork.
 */
export const playbackStates = (bubbles: Bubble[], pathOf: (id: string) => string[] | undefined, pages: string[], mode: FunnelMode): OpenState[] =>
  bubbles.map((b) => {
    const path = pathOf(b.id);
    const p = progressOf(path && path.length ? path : [b.page], pages, mode);

    return { id: b.id, k: p.k, broken: p.broken, page: b.page };
  });
